import React, { Component } from 'react';
import { graphql } from 'gatsby';
import { ContentHeader, SEO } from '../components';
const { getAdocFullPath, isHomePage } = require('../../lib');

class DocPage extends Component {
  constructor(props) {
    super(props);
    this.pageData;
    this.pageHtml;
    this.readTime;
    this.lastModified;
    this.init();
  }

  init() {
    const {
      pageData,
      pageHtml,
      pageContext: { redirectPath, status },
    } = this.props;
    this.pageData = pageData;
    this.pageHtml = pageHtml;
    this.readTime = pageData.readTime;
    this.lastModified = pageData.lastModified;

    const fullPath = getAdocFullPath(pageData.urlCollection, pageData.urlTitle);
    this.isHomePage = isHomePage(status);

    this.seoOptions = {
      desc: pageData.description,
      url: `${process.env.GATSBY_DOCS_URL}${fullPath}`,
      title: pageData.title,
      status: status,
    };

    if (redirectPath) {
      seoOptions.redirectUrl = `${process.env.GATSBY_DOCS_URL}${redirectPath}`;
    }
  }

  render() {
    return (
      <>
        <SEO {...this.seoOptions} />
        {!this.isHomePage && (
          <ContentHeader lastModified={this.lastModified} readTime={this.readTime} />
        )}
        {this.pageHtml}
      </>
    );
  }
}

export default DocPage;

export const pageQuery = graphql`
  query ($id: String!) {
    asciidoc(id: { eq: $id }) {
      html
      document {
        description
        status
        subtitle
        tags
        title
        urlCollection
        urlTitle
        navTitle
        lastModified
        readTime
      }
    }
  }
`;
